import { TourDefinition } from '../types'

// Walks new/confused users through the sidebar navigation, stopping at each major
// section to explain what it is and what they'll find there.
//
// data-tour targets live on the sidebar menu items in base-layout.tsx:
//   "nav-self-paced"    — Self-Paced (top-level)
//   "nav-live-classes"  — Live Classes (under Learning)
//   "nav-progress"      — Progress group header (top-level)
//   "nav-learning-paths"— Learning Paths (under Progress)
//   "nav-ibsc-100"      — IBSC 100-Hour (under Progress)
//   "nav-ibsc-40"       — IBSC 40-Hour (under Progress)
//
// base-layout.tsx opens the drawer and expands the Learning/Progress groups while
// this tour is active so every target is rendered when its step shows.
//
// Copy below was drafted and finalized with the requester (Shawn) — treat as final
// wording, not a placeholder.

export let SIDEBAR_NAVIGATION_TOUR_ID = 'sidebar-navigation'

export let sidebarNavigationTour: TourDefinition = {
  id: SIDEBAR_NAVIGATION_TOUR_ID,
  version: 1,
  name: 'Finding Your Way Around',
  description:
    'A guided walk through the sidebar so you know where to find what you need.',
  startingRoute: '/self-paced',
  steps: [
    {
      target: '[data-tour="nav-self-paced"]',
      placement: 'right',
      title: 'Self-Paced',
      content:
        'Browse all of our self-paced courses. All courses are both CAPCE & ANCC accredited and are sorted by category to help you fulfill your state and/or NREMT recertification requirements.',
    },
    {
      target: '[data-tour="nav-live-classes"]',
      placement: 'right',
      title: 'Live Classes',
      content:
        'Join our live, instructor-led (F5) Classes, Monday through Friday.',
    },
    {
      target: '[data-tour="nav-progress"]',
      placement: 'right',
      title: 'Progress',
      content:
        'This is your Progress hub — pre-built guides and learning paths that do the planning for you, instead of picking courses one at a time.',
    },
    {
      target: '[data-tour="nav-learning-paths"]',
      placement: 'right',
      title: 'Learning Paths',
      content:
        'Built based on your license type, a Learning Path covers the National Component of your NREMT recertification.',
    },
    {
      target: '[data-tour="nav-ibsc-100"]',
      placement: 'right',
      title: 'IBSC 100-Hour',
      content:
        'This is our IBSC 100-Hour course — a full refresher for FP-C and CCP-C flight and critical care paramedics only, covering your entire renewal requirement in one place. It includes our 16-hour review course if completed in full.',
    },
    {
      target: '[data-tour="nav-ibsc-40"]',
      placement: 'right',
      title: 'IBSC 40-Hour',
      content:
        'This is our IBSC 40-Hour course, built for FP-C and CCP-C paramedics only, who already have renewal hours from an employer or another program and just need to round out the rest. It includes our 16-hour review course if completed in full.',
    },
  ],
}
